import moment from 'moment';

export const handleTimeConversion = (time) => {
    const timeToUse = time || time.target?.value;
    const isValidTime = moment(timeToUse, 'HH:mm:ss').isValid();
    return isValidTime ? new Date(`2014-08-18T${timeToUse}`) : new Date('2014-08-18T00:00:00');
};
//Converts a time value in the format HH:mm:ss to a Date object.
export const convertToDate = (time) => {
    const validTime = time || time.target?.value;
    return moment(validTime, 'HH:mm:ss').isValid()
        ? new Date(`2014-08-18T${validTime}`)
        : new Date('2014-08-18T00:00:00');
};


/**
 * Converts a time string in the format "HH:mm:ss" or "HH:mm" to military hour format.
 * Example: "07:30:00" → 730, "20:20:20" → 2020
 *
 * @param {string} timeString - A string representing time in "HH:mm:ss" or "HH:mm" format.
 * @returns {number|null} The military hour as a number (e.g., 1330), or null if invalid.
 */
export const toMilitaryHour = (timeString) => {
    if (typeof timeString !== 'string') return null;

    const parts = timeString.split(':');
    if (parts.length !== 2) return null;

    const [hours, minutes] = parts;
    if (
        isNaN(hours) ||
        isNaN(minutes) ||

        hours.length !== 2 ||
        minutes.length !== 2
    ) {
        return null;
    }

    return `${hours}${minutes}`;
};
/**
 * Converts a military hour number (e.g., 800, 1330) to a time string in "HH:mm:ss" format.
 *
 * Examples:
 *   800  -> "08:00:00"
 *   1330 -> "13:30:00"
 *
 * @param {number} militaryNumber - The time in military time format as a number.
 * @returns {string} The time formatted as a string in "HH:mm:ss". Returns an empty string if input is invalid.
 */
export const militaryHourToTimeString = (militaryNumber) => {
    if (typeof militaryNumber !== 'number') return '';

   const str = militaryNumber.toString().padStart(4, '0');
    const hh = str.slice(0, 2);
    const mm = str.slice(2, 4);

    return `${hh}:${mm}`;
};
/**
 * Converts a time string in the format "HH:mm" into a JavaScript `Date` object.
 *
 * @param {string} timeString - A string representing time in the "HH:mm" format (24-hour clock).
 * @returns {Date|null} A `Date` object with the specified hours and minutes set,
 *                      or `null` if the input is invalid.
 */
export const timeStringToDate = (timeString) => {
    if (!timeString || typeof timeString !== 'string') return null;

    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
};
